module.exports = __webpack_public_path__ + "img/wordpress.7188d9b6.png";